(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const filters = document.querySelectorAll('input[name="blog-filter"]');
  let lastCheckedFilter = null;

  filters.forEach(filter => {
    // Listen to click event BEFORE the change happens
    filter.addEventListener('click', function (e) {
      // If the user clicks the same already-selected filter
      if (this === lastCheckedFilter) {
        e.preventDefault(); // Prevent it from staying selected
        const baseUrl = window.location.href.split('/tagged/')[0];
        window.location.href = baseUrl;
        return;
      }

      // Update the last selected filter
      lastCheckedFilter = this;
    });

    // Normal behavior when a new filter is selected
    filter.addEventListener('change', function () {
      const url = this.dataset.filter;
      if (url) {
        window.location.href = url;
      }
    });
  });

  // Handle "Clear All" button
  const clearBtn = document.querySelector('.nx-filterdrop--clearbtn');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      const baseUrl = window.location.href.split('/tagged/')[0];
      window.location.href = baseUrl;
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
